import type { ThemeOptions } from '@mui/material'
import type { SnackbarProviderProps } from 'notistack'

import { tableColor as table } from './palette'

/**
 * Legacy components overrides, that existed before the Redesign.
 * TODO: These overrides should be refined and then either be moved to components.ts or deleted.
 * @see https://cybusio.atlassian.net/browse/CC-4243
 */

export const SnackbarConfig: Required<Pick<SnackbarProviderProps, 'className'>> & SnackbarProviderProps = {
    className: 'status-notification',
    maxSnack: 5,
    preventDuplicate: true,
}

export const componentsOverrides: ThemeOptions['components'] = {
    MuiTableContainer: {
        styleOverrides: {
            root: {
                border: '1px solid',
                borderColor: table.tableborder,
            },
        },
    },
    MuiTableRow: {
        styleOverrides: {
            root: {
                ':last-child>td': {
                    borderBottom: 'none',
                },
            },
            head: {
                backgroundColor: 'white',
            },
        },
    },
    MuiTableCell: {
        styleOverrides: {
            root: {
                borderBottomColor: table.cellborder,
                borderRightColor: table.cellborder,
            },
            sizeMedium: {
                padding: '16px',
            },
            sizeSmall: {
                padding: '0px 16px',
            },
            head: {
                backgroundColor: table.headerbackground,
                lineHeight: '22px',
            },
            body: {
                lineHeight: '16px',
            },
            paddingCheckbox: {
                padding: '0 13px',
                width: 'auto',
            },
        },
    },
    MuiTableSortLabel: {
        styleOverrides: {
            root: {
                verticalAlign: 'unset',
            },
        },
    },
    MuiDialog: {
        styleOverrides: {
            container: ({ theme }) => ({
                /** Leave space for the notification so that the dialog buttons are still visible */
                [theme.breakpoints.down('xl')]: {
                    [`body:has(.${SnackbarConfig.className}) &`]: {
                        justifyContent: 'start',
                        maxWidth: '70vw',
                    },
                },
            }),
        },
    },
}
